angular.module('app').config(clientProfilesRouting);

function clientProfilesRouting($routeProvider) {
  $routeProvider
    .when('/client_profiles', {
      pageTitle: 'CLIENT_PROFILES',
      template: '<client-profiles-page></client-profiles-page>',
      breadcrumb: {
        label: 'COMPANY_SETTINGS',
        parent: 'ng/company_settings',
      },
      menu: 'settings',
      accessPermission: 'index_clientprofile_accountadmin',
      authReq: true,
    })
    .when('/client_profiles/new', {
      pageTitle: 'ADD_CLIENT_PROFILE',
      template: '<client-profile-page></client-profile-page>',
      breadcrumb: {
        label: 'CLIENT_PROFILES',
        parent: 'client_profiles',
        ajs: true,
      },
      menu: 'settings',
      accessPermission: 'create_clientprofile_accountadmin',
      authReq: true,
    })
    .when('/client_profiles/:id', {
      pageTitle: 'EDIT_CLIENT_PROFILE',
      template: '<client-profile-page></client-profile-page>',
      breadcrumb: {
        label: 'CLIENT_PROFILES',
        parent: 'client_profiles',
        ajs: true,
      },
      menu: 'settings',
      accessPermission: 'show_clientprofile_accountadmin',
      authReq: true,
    });
}

clientProfilesRouting.$inject = ['$routeProvider'];
